import { render } from "./MovieEditView.vue?vue&type=template&id=a79b571a"
import script from "./MovieEditView.vue?vue&type=script&lang=js"
export * from "./MovieEditView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__